import _debounce from 'lodash/debounce';
import React from 'react';
import { event } from '@zillow/universal-analytics';
import { FieldConfig } from './HelocCalculator.utils.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import TextField from '../Fields/TextField.js';

// debounced by 3 seconds.
var sendFieldInteractionEvent = _debounce(function (label) {
  var newLaneData = {
    envelope: {
      event_type_id: '2056',
      event_type_version_id: '3',
      event_template_id: '126',
      event_template_version_id: '1'
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms_form',
      trigger_object_nm: 'no_trigger_object'
    },
    semantic: {
      semantic_event_nm: 'cms_engagement'
    },
    cms_info: {
      block_type_cd: 'form_field',
      block_id: 'heloc_calc',
      block_displayed_txt: label
    }
  };
  event(newLaneData);
}, 3000);
function HelocFields() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    label: "Estimated home value",
    leftAdornment: "$",
    name: FieldConfig.homeValue.name,
    config: FieldConfig.homeValue.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true,
    onChange: function onChange() {
      sendFieldInteractionEvent('Estimated home value');
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Loan balance",
    leftAdornment: "$",
    name: FieldConfig.loanBalance.name,
    config: FieldConfig.loanBalance.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true,
    onChange: function onChange() {
      sendFieldInteractionEvent('Loan balance');
    }
  }));
}

export { HelocFields as default, sendFieldInteractionEvent };
